import { Text } from '@quintoandar-tokko/jopijs';
import styles from './components.module.scss';

export default function RowName({ text, className = '', ...props }) {
  const classNames = `${styles.rowName} ${className}`;

  return (
    <Text className={classNames} {...props}>
      {text}
    </Text>
  );
}
